import { render, staticRenderFns } from "./MirrorZoneView.vue?vue&type=template&id=540e77a6&scoped=true&"
import script from "./MirrorZoneView.vue?vue&type=script&lang=js&"
export * from "./MirrorZoneView.vue?vue&type=script&lang=js&"
import style0 from "./MirrorZoneView.vue?vue&type=style&index=0&id=540e77a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e77a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VChip,VExpandTransition,VIcon,VProgressCircular})
